import { useState, useEffect } from 'react';

/**
 * Hook to manage sidebar toggle state for responsive dashboard
 * Automatically handles mobile breakpoint detection
 */
export const useSidebarToggle = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Check if screen is mobile size
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
      // Auto-close sidebar on desktop
      if (window.innerWidth > 768) {
        setIsSidebarOpen(false);
      }
    };

    // Initial check
    checkMobile();

    // Add resize listener
    window.addEventListener('resize', checkMobile);

    // Cleanup
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const closeSidebar = () => {
    setIsSidebarOpen(false);
  };

  return {
    isSidebarOpen,
    isMobile,
    toggleSidebar,
    closeSidebar,
  };
};
